/* eslint-disable no-restricted-globals */

import xss from "xss";

/**
 * This can be used to host the server at a more nested path
 *
 * EXAMPLE: my.partner.com/has/more/deeply/nested/cart/page
 * ... would return `"/has/more/deeply/nested/cart/page"`
 */
export function getPartnerPathnameClient(isURLPrefix?: boolean) {
  const language = xss(location.pathname.split("/")[1]);
  const pathPrefix = ["en", "ja"].includes(language) ? `${language}/` : "";

  return (isURLPrefix ? `/` : "") + `${pathPrefix}cart`;
}
